import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import EditTable from '../EditTable';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';

class MarkUpRates extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			rates: [],
			editable: false,
			editorsOpen: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadRates();
	}

	loadRates() {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'MARK_UP_RATE',
				search: { Operator: 'and', Children: [
					{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
					{ Attribute: 'SHOP_ID', Operator: '<', LongValue: 50 }]},
				order: 'RATE_ID desc',
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				for (var i = 0; i < data.Data.length; i++) {
					data.Data[i].id = i;
				}
				self.mergeState({ rates: data.Data });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState, accessor, value);
		newState.renderKey = this.state.renderKey + 1;

		// if this accessor represents an EditTable
		if (['rates'].includes(accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.setState(newState);
	}

	onSubmit(event) {
		var self = this;

		if (this.state.editorsOpen.includes('rate')) {
			this.showAlert('Editor Open', 'Please close the mark up rate editor before saving.');
		} else {
			var rates = this.copyObject(this.state.rates);

			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/UpdateMarkUpRates',
				overlay: true,
				data: {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					rates: {
						rates: rates
					}
				}
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Mark Up Rates successfully updated.
						</>);
					});				
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Current Markup Rate&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
						<div style={{ marginBottom: '10px' }}>
							Please make sure there is only one valid rate with no end date at a time.
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
						  data={this.state.rates} editable={this.state.editable} tableColumns={rateTableColumns} 
						  editColumns={rateEditColumns} tableName='Jobtrack_MarkUpRates' newRecord={emptyRate}
						  onEdit={(editorIsOpen, idx) => this.onEdit('rates', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('rates', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
						{this.state.editable && <Button id="save" variant="warning" type="button" className="float-end" onClick={() => this.onSubmit()}>Save</Button>}
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const emptyRate = {
	id: null,
	RATE_ID: null,
	RATE_PCT: '',
	START_DATE: null,
	END_DATE: null,
	VALID_FLAG: 'Y',
	SHOP_ID: 1,
	COMMENTS: '',
	CREATED_BY: '',
	DATE_CREATED: null,
	DATE_MODIF: null,
	MODIF_BY: '',
	DELETE_FLAG: null
};

const rateTableColumns = [
	{ Header: 'ID', accessor: 'RATE_ID', width: 60 },
	{ Header: 'Mark Up Rate', accessor: 'RATE_PCT', width: 90 },
	{ Header: 'Start Date', accessor: 'START_DATE', width: 100,
		Cell: props => props.parent.dateToString(props.parent.getDate(props.value)) },
	{ Header: 'End Date', accessor: 'END_DATE', width: 100,
		Cell: props => props.parent.dateToString(props.parent.getDate(props.value)) },
	{ Header: 'Valid Rate', accessor: 'VALID_FLAG', width: 80 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 300 }
];

const rateEditColumns = [
	{ Header: 'ID', accessor: 'RATE_ID', row: 0, col: 0, editable: false },
	{ Header: 'Mark Up Rate', accessor: 'RATE_PCT', row: 0, col: 1, required: true },
	{ Header: 'Start Date', accessor: 'START_DATE', type: 'date', row: 1, col: 0, required: true },
	{ Header: 'End Date', accessor: 'END_DATE', type: 'date', row: 1, col: 1 },
	{ Header: 'Valid Rate', accessor: 'VALID_FLAG', type: 'checkbox', row: 2, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 2, col: 1 },
];

export default withRouter(MarkUpRates);
